import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=e550fc34&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=ts"
export * from "./homepage.vue?vue&type=script&lang=ts"
import style0 from "./homepage.vue?vue&type=style&index=0&id=e550fc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e550fc34",
  null
  
)

export default component.exports